import Badge from "./Badge";
import Panel from "./Panel";
import styles from "./PagePlaceholder.module.css";

interface PagePlaceholderProps {
  /** Page title, rendered in the Title role (14px/600). */
  title: string;
  /** One line describing what this view will hold once it is built. */
  summary: string;
}

/**
 * Stand-in for a page that has no implementation yet. Renders the standard
 * page chrome — title, a placeholder badge, and a single panel — so the shell,
 * the rail navigation, and both themes can be exercised before any domain
 * content exists. Replace each usage with the real page component.
 */
function PagePlaceholder({ title, summary }: PagePlaceholderProps) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
        <Badge variant="info">Placeholder</Badge>
      </header>

      <Panel title="Nothing here yet">
        <p className={styles.summary}>{summary}</p>
      </Panel>
    </div>
  );
}

export default PagePlaceholder;
